import { User, Users, Building2, Landmark, Coins, MapPin } from "lucide-react";
import { Input } from "@/components/ui/input";

export const ACTORS = [
  { id: "Warga / Individu", icon: User },
  { id: "Komunitas / Relawan", icon: Users },
  { id: "Perusahaan / CSR", icon: Building2 },
  { id: "Institusi / Kampus", icon: Landmark },
];

export const isCorporate = (actor) => actor === "Perusahaan / CSR" || actor === "Institusi / Kampus";

export default function ActorSelector({ actor, setActor, budget, setBudget, region, setRegion }) {
  const corporate = isCorporate(actor);
  return (
    <div className="space-y-3 mb-4">
      <p className="text-sm font-bold text-slate-700">Siapa pelaksana aksinya?</p>
      <div className="flex flex-wrap gap-2">
        {ACTORS.map((a) => (
          <button
            key={a.id}
            data-testid={`actor-chip-${ACTORS.indexOf(a)}`}
            onClick={() => setActor(a.id)}
            aria-pressed={actor === a.id}
            className={`flex items-center gap-1.5 px-4 py-2 rounded-full border-2 text-sm font-bold transition-colors ${
              actor === a.id ? "border-emerald-600 bg-emerald-50 text-emerald-800" : "border-slate-200 bg-white text-slate-600 hover:border-emerald-300"
            }`}
          >
            <a.icon className="w-4 h-4" /> {a.id}
          </button>
        ))}
      </div>
      <div className={`grid grid-cols-1 sm:grid-cols-2 gap-3 rounded-xl transition-colors ${corporate ? "bg-emerald-50 border-2 border-emerald-200 p-3" : ""}`}>
        <div className="relative">
          <Coins className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" aria-hidden="true" />
          <Input
            data-testid="planner-budget-input"
            type="number"
            min="0"
            placeholder={corporate ? "Alokasi Dana (Rp) — direkomendasikan" : "Alokasi Dana (Rp) — opsional"}
            aria-label="Alokasi dana dalam Rupiah"
            value={budget}
            onChange={(e) => setBudget(e.target.value)}
            className="rounded-xl pl-9 bg-white"
          />
        </div>
        <div className="relative">
          <MapPin className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" aria-hidden="true" />
          <Input
            data-testid="planner-region-input"
            placeholder="Kota / Wilayah Target"
            aria-label="Kota atau wilayah target"
            value={region}
            onChange={(e) => setRegion(e.target.value)}
            className="rounded-xl pl-9 bg-white"
          />
        </div>
      </div>
    </div>
  );
}
